import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectIsCompetitorsFetchingLoading = createSelector(
  [selectCompetitorsSobState],
  ({ fetchCompetitorsStatus, fetchCompetitorsForSelectStatus }) =>
    fetchCompetitorsStatus === RequestStatus.PENDING ||
    fetchCompetitorsForSelectStatus === RequestStatus.PENDING
)
